import { render } from "./EditShifts.vue?vue&type=template&id=a56fccec"
import script from "./EditShifts.vue?vue&type=script&lang=js"
export * from "./EditShifts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__